<template>
  <div class="page">
    <img class="bg" alt src="../../assets/bg.png" />
    <div class="user-info" @click="infoClick">
      <img class="avatar" :src="userInfo.avatar" alt="avatar" />
      <div class="column">
        <div class="user-name">{{ userInfo.name }}</div>
        <div v-if="userInfo.phone != null" class="phone">
          {{ userInfo.phone }}
        </div>
      </div>
    </div>

    <div class="icon-menu-layout">
      <div
        class="icon-menu"
        v-for="(item, index) in iconMenus"
        :key="item.name + index"
        @click="goto(item.url)"
      >
        <img :src="item.icon" alt="menu icon" />
        <div>{{ item.name }}</div>
      </div>
    </div>

    <div class="list-menu-layout">
      <div
        class="list-menu"
        v-for="(item, index) in listMenus"
        :key="item.name + index"
        @click="goto(item.url)"
      >
        <div>{{ item.name }}</div>
      </div>
    </div>

    <div class="footer">
      <div>广东品胜电子股份有限公司版权所有</div>
      <div>联系电话 400-088-9898</div>
    </div>
  </div>
</template>

<script>
import { login } from "../../scripts/auth";
export default {
  name: "Mine",
  data() {
    return {
      iconMenus: [
        {
          icon: require("../../assets/mine-cart.png"),
          name: "购物车",
          url: "https://shop16436071.youzan.com/wsctrade/cart"
        },
        {
          icon: require("../../assets/mine-repair.png"),
          name: "维修优惠",
          url: "https://r.piseneasy.com/wechat/discount"
        },
        {
          icon: require("../../assets/mine-discounts.png"),
          name: "商品优惠",
          url: "https://shop16436071.youzan.com/wscump/coupon/collection"
        },
        {
          icon: require("../../assets/mine-order.png"),
          name: "活动中心",
          url: "https://r.piseneasy.com/pro/page/107"
        }
      ],
      listMenus: [
        { name: "在线客服", url: "xiaoneng" },
        { name: "常见问题", url: "https://r.piseneasy.com/wechat/faq" },
        { name: "意见反馈", url: "https://r.piseneasy.com/wechat/contactus" }
      ]
    };
  },
  computed: {
    userInfo() {
      let info = this.$store.state.userInfo;
      let res = {};
      if (info) {
        res.avatar = info.avatar || require("../../assets/default-avatar.png");
        res.name = info.name;
        res.phone = info.phone;
        res.isLogin = true;
      } else {
        res.avatar = require("../../assets/default-avatar.png");
        res.name = "未登录";
        res.phone = null;
        res.isLogin = false;
      }
      return res;
    }
  },
  created: function() {},
  methods: {
    infoClick() {
      if (!this.userInfo.isLogin) {
        login(this.$store, this.$router);
      }
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #b38b5f, #f5f5f5 30%, #f5f5f5 100%);
  overflow: hidden;
  position: relative;
}

.bg {
  position: absolute;
  top: 12px;
  right: 0;
  width: 341px;
  height: 164px;
}

.user-info {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 62px;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: 28px;
  margin-left: 24px;
  margin-right: 18px;
}

.column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: black;
}

.phone {
  background: #3b2e31;
  height: 18px;
  line-height: 18px;
  color: #e8dcc0;
  border-radius: 9px;
  font-size: 10px;
  padding: 0 8px;
  margin-top: 6px;
  letter-spacing: 1px;
}

.icon-menu-layout {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 35px 14px 0 14px;
  background: white;
  height: 72px;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0px 4px 15px 0px rgba(88, 88, 88, 0.1);
}

.icon-menu {
  font-size: 10px;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 400;
}

.icon-menu img {
  width: 30px;
  height: 30px;
  margin-bottom: 8px;
}

.list-menu-layout {
  display: flex;
  flex-direction: column;
  margin: 24px 14px 0 14px;
  background: white;
  border-radius: 10px;
}

.list-menu {
  height: 56px;
  line-height: 56px;
  padding-left: 18px;
  color: black;
  font-size: 14px;
  font-weight: 400;
  position: relative;
}

.list-menu + .list-menu::after {
  content: " ";
  position: absolute;
  width: 100%;
  height: 1px;
  top: 0;
  left: 0;
  border-bottom: #c5c5c533 1px solid;
}

.footer {
  text-align: center;
  width: 100%;
  color: #999999;
  font-size: 10px;
  line-height: 18px;
  margin-top: 50px;
}
</style>